module.exports = "../../static/fonts/Gotham-Book.b2df243.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Gotham-Book.ttf
// module id = QT5l
// module chunks = 47